import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import MerchantForm from "./MerchantComponents/MerchantForm";

import {
  useGetMerchantDetailQuery,
  useUpdateMerchantMutation,
} from "store/services/merchantApi";

import { useAppMeta } from "hooks";

const MerchantEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Merchants", path: "/app/crm/merchant/list" },
    { title: "Edit Merchant" },
  ];

  // RTK Query
  const {
    data: merchantDetail,
    isLoading: loadingMerchant,
    error,
  } = useGetMerchantDetailQuery(id);

  const [updateMerchant, { isLoading: updatingMerchant }] =
    useUpdateMerchantMutation();

  // Update handler
  const handleMerchantUpdate = async (data) => {
    const payload = { id, ...data };

    try {
      await updateMerchant(payload).unwrap();
      toast.success("Merchant successfully updated!");
      navigate(`/app/crm/merchant/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update merchant!"
      );
    }
  };

  useAppMeta("Edit Merchant");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingMerchant || updatingMerchant}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <MerchantForm
          isBusy={loadingMerchant || updatingMerchant}
          merchantDetail={merchantDetail}
          onSubmit={handleMerchantUpdate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default MerchantEditScreen;